import { Card, Form } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import { useEffect, useRef, useState } from "react";
import WebService from "../../utility/WebService";
import { PencilFill, TrashFill } from "react-bootstrap-icons";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import AddTag from "./AddTag";
import CustomTableSortable from "../../components/CustomTable/CustomTableSortable";
import HelperService from "../../utility/HelperService";

const columns = [
  {
    id: "createdAt",
    label: "Created Date",
    minWidth: 170,
    sortable: true,
  },
  {
    id: "name",
    label: "Name",
    minWidth: 170,
    sortable: true,
  },
  {
    id: "type",
    label: "Type",
    minWidth: 170,
    sortable: true,
  },
  {
    id: "action",
    label: "Action",
    minWidth: 100,
    align: "center" as any,
  },
];

const Tag = () => {
  const [showAddLeadershipCouncil, setShowAddLeadershipCouncil] =
    useState(false);
  const [leadershipCouncils, setLeadershipCouncils] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [leadershipCouncilToDelete, setLeadershipCouncilToDelete] = useState<
    string | null
  >(null);
  const [leadershipCouncilToEdit, setLeadershipCouncilToEdit] = useState<
    any | null
  >(null);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [search, setSearch] = useState("");
  const searchRef = useRef<string>("");
  const [type, setType] = useState("ALL");
  const typeRef = useRef<string>("");
  const [sortField, setSortField] = useState<string>("createdAt");
  const [sortOrder, setSortOrder] = useState<"asc" | "desc">("desc");
  const [uiSortField, setUiSortField] = useState<string>("createdAtFormatted");
  const [loading, setLoading] = useState<boolean>(false);
  const sortFieldMap: Record<string, string> = {
    createdAtFormatted: "createdAt",
    name: "name",
    type: "type",
    status: "status",
    createdAt: "createdAt",
  };
  const [pagePermission, setPagePermission] = useState({
    canView: false,
    canAdd: false,
    canEdit: false,
    canDelete: false,
  });
  useEffect(() => {
    getMediaTags(searchRef.current, typeRef.current);
  }, [currentPage, sortField, sortOrder]);

  const tagTypes = [
    { id: "NEWS", label: "News" },
    // { id: "BLOG", label: "Blog" },
    // { id: "GALLERY", label: "Gallery" },
    { id: "INDUSTRY_REPORT", label: "Industry Report" },
    { id: "TENDERS", label: "Tenders" },
    { id: "PRESENTATION", label: "Presentation" },
    { id: "KNW_PAPER", label: "Monthly Report" },
    { id: "RESOURCE_INDEX", label: "Index" },
    { id: "WORKING_GROUP", label: "Working Group" },
    { id: "REGULATION", label: "Representations" },
    { id: "EVENT", label: "Event" },
  ];
  const getMediaTags = (keyword = "", typeId = "") => {
    const params = new URLSearchParams();
    params.append("page", currentPage.toString());
    params.append("limit", itemsPerPage.toString());

    // Status filter
    // if (search && search !== "ALL") {
    //   params.append("status", search);
    // }    

    // Keyword search
    if (keyword.trim()) {
      params.append("keyword", keyword.trim());
    }

    // Type filter (if needed)
    if (typeId) {
      params.append("type", typeId);
    }

    // Sorting
    params.append("sortField", sortField);
    params.append("sortOrder", sortOrder);

    WebService.getAPI({
      action: `tags/list?${params.toString()}`,
    })
      .then((res: any) => {
        const perm = res?.data?.permissions || {};

        setPagePermission({
          canView: perm.canView,
          canAdd: perm.canAdd,
          canEdit: perm.canEdit,
          canDelete: perm.canDelete,
        });
        const formattedRows = res?.data?.data.map((item: any) => ({
          ...item,
          createdAt: HelperService.getFormatedDate(item.createdAt),
          type: item.type === "KNW_PAPER"
            ? "Monthly Report"
            : item.type === "RESOURCE_INDEX"
              ? "Index"
              : item.type === "REGULATION"
              ? "Representations"
              : item.type
                ? item.type
                    .toLowerCase()
                    .replace(/_/g, " ")
                    .replace(/\b\w/g, (l: string) => l.toUpperCase())
                : "",
          action: (
            <div>
              {perm.canEdit && (
                <PencilFill
                  className="me-3 cursor-pointer"
                  onClick={() => {
                    setShowAddLeadershipCouncil(true);
                    setLeadershipCouncilToEdit(item);
                  }}
                  title="Edit"
                />
              )}
              {perm.canDelete && (
                <TrashFill
                  color="#DC143C"
                  className="cursor-pointer"
                  onClick={() => handleDeleteEvent(item._id)}
                  title="Delete"
                />
              )}
            </div>
          ),
        }));
        setLeadershipCouncils(formattedRows);
        setTotalCount(res?.data?.pagination?.total);
      })
      .catch(() => {});
  };

  const handleDeleteEvent = (leadershipCouncilId: string) => {
    setLeadershipCouncilToDelete(leadershipCouncilId);
    setShowDeleteModal(true);
  };

  return (
    <>
      <AddTag
        show={showAddLeadershipCouncil}
        handleClose={() => {
          setShowAddLeadershipCouncil(false);
          setLeadershipCouncilToEdit(null);
          getMediaTags(searchRef.current, typeRef.current);
        }}
        data={leadershipCouncilToEdit}
      />
      <DeleteModal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        onDelete={() => {
          if (leadershipCouncilToDelete) {
            WebService.deleteAPI({
              action: `tags/delete-tag/${leadershipCouncilToDelete}`,
            }).then(() => {
              setShowDeleteModal(false);
              getMediaTags(searchRef.current, typeRef.current);
            });
          }
        }}
        message="Are you sure you want to delete this tag?"
      />
      <div className="events-main">
        <Card className="event-card">
          <div className="d-flex justify-content-between">
            <div className="page-title">Tags</div>
            {pagePermission.canAdd && (
              <CustomButton
                isLoading={false}
                label="Add"
                onClick={() => {
                  setLeadershipCouncilToEdit(null);
                  setShowAddLeadershipCouncil(true);
                }}
                style={{ width: 100 }}
              />
            )}
          </div>
          <div className="row">
            <div className="col-md-3">
              <Form.Label className="label">Search</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter name"
                value={search}
                onChange={(e) => {
                  const value = e.target.value;
                  searchRef.current = value;
                  setSearch(value);
                  setCurrentPage(1);
                  getMediaTags(searchRef.current, typeRef.current);
                }}
              />
            </div>

            <div className="col-md-3">
              <Form.Label className="label">Type</Form.Label>
              <Form.Select
                value={type}
                onChange={(e) => {
                  // const selectedType = e.target.value;
                  // setType(selectedType);
                  // setCurrentPage(1);
                  // getMediaTags(
                  //   search,
                  //   selectedType === "ALL" ? "" : selectedType,
                  // );
                  const selectedType = e.target.value;
                  const finalType = selectedType === "ALL" ? "" : selectedType;

                  typeRef.current = finalType;
                  setType(selectedType);
                  setCurrentPage(1);
                  getMediaTags(searchRef.current, typeRef.current);                  
                }}
              >
                <option value="ALL">All</option>
                {tagTypes.map((t) => (
                  <option key={t.id} value={t.id}>
                    {t.label}
                  </option>
                ))}
              </Form.Select>
            </div>
          </div>

          <CustomTableSortable
            columns={columns}
            rows={leadershipCouncils}
            totalCount={totalCount}
            currentPage={currentPage}
            pageSize={itemsPerPage}
            onPageChange={(page) => {
              setCurrentPage(page);
            }}
            isLoading={loading}
            sortField={uiSortField}
            sortOrder={sortOrder}
            onSortChange={(columnId, order) => {
              setUiSortField(columnId);
              setSortOrder(order);
              const apiField = sortFieldMap[columnId] || "createdAt";
              setSortField(apiField);
              setCurrentPage(1);
              // Fetch is driven by the useEffect (now depends on sortField/sortOrder) using fresh state.
            }}
          />
        </Card>
      </div>
    </>
  );
};

export default Tag;
